export default __webpack_public_path__ + "static/media/7.772a2359.jpg";